type RetryButtonProps = {
  onClick: () => void;
};

/**
 * The retry link inside a "please try again" sentence.
 *
 * Its text comes from the translation bundle through `<Trans>`, so the element itself carries
 * only the handler — which is why the a11y rule cannot see a label here. Keeping that exemption
 * in one place rather than repeating it at every error state (EN-5191).
 */
export function RetryButton({ onClick }: RetryButtonProps) {
  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <button type="button" onClick={onClick} />
  );
}
